import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  // Close on escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [onClose]);
  return <AnimatePresence data-id="element-158">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 z-50 bg-warm-900/40 backdrop-blur-sm" aria-hidden="true" data-id="element-159" />

          {/* Modal Container */}
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none" data-id="element-160">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          type: 'spring',
          duration: 0.5,
          bounce: 0.3
        }} className="w-full max-w-2xl bg-white rounded-2xl shadow-2xl pointer-events-auto flex flex-col max-h-[85vh]" role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-161">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-warm-100" data-id="element-162">
                <h2 id="modal-title" className="text-2xl font-bold font-display text-warm-900" data-id="element-163">
                  {title}
                </h2>
                <button onClick={onClose} className="p-2 text-warm-400 hover:text-warm-900 hover:bg-warm-50 rounded-full transition-colors" aria-label="Close modal" data-id="element-164">
                  <X className="w-5 h-5" data-id="element-165" />
                </button>
              </div>

              {/* Content - Scrollable */}
              <div className="p-6 overflow-y-auto custom-scrollbar" data-id="element-166">
                <div className="prose prose-warm max-w-none text-warm-900/80" data-id="element-167">
                  {children}
                </div>
              </div>

              {/* Footer */}
              <div className="p-6 border-t border-warm-100 bg-warm-50/50 rounded-b-2xl flex justify-end" data-id="element-168">
                <button onClick={onClose} className="px-6 py-2 bg-warm-200 hover:bg-warm-300 text-warm-900 font-medium rounded-lg transition-colors text-sm" data-id="element-169">
                  Cerrar
                </button>
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}